import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export type StagedContentLinkClickCommandProperties = CommandProperties & {
	url: string;
};

/**
 * Asks the Rovo chat host whether a smart-link card clicked inside the smart-create editor iframe
 * points to an unfinalized staged item in the active conversation. Resolves `true` when the host
 * handled the click (it selected / opened that item in the staging area) and `false` when it
 * declined, in which case the sender keeps its default click behaviour.
 */
export const StagedContentLinkClickCommand: CommandConstructor<
	StagedContentLinkClickCommandProperties,
	boolean
> = createCommand<StagedContentLinkClickCommandProperties, boolean>(
	'staged-content-link-click-command',
);
